import { Container, Img, Link, Section, Text } from '@react-email/components';

/**
 * Correo de una reserva que se repite.
 *
 * Es deliberadamente corto. La plantilla de una reserva suelta lista los 17
 * campos del formulario —cédula, dirección de facturación, requerimientos…— y
 * repetir todo eso para doce fechas no ayuda a nadie: lo que hace falta es
 * cuántas son, qué días, dónde, y un enlace para verlas.
 *
 * El detalle de cada fecha vive en la página que abre ese enlace, no aquí:
 * un correo con doce filas se rompe en la mitad de los clientes de correo.
 */

interface EmailProps {
  logoUrl: string;
  headerTitle: string;
  headerSubtitle: string;
  footer1: FooterProps;
  footer2: FooterProps;
  lang: 'es' | 'en';
}

export const TemplateRecurringReservationEmail = ({
  logoUrl,
  headerTitle,
  headerSubtitle,
  footer1,
  footer2,
  lang,
}: EmailProps) => {
  const es = lang === 'es';

  return (
    <Container style={container}>
      <Section>
        <Img style={{ margin: '0 auto' }} src={logoUrl} width='80' alt='Logo' />
      </Section>
      <Section>
        <Text style={text}>{headerTitle}</Text>
        <Text style={text}>{headerSubtitle}</Text>

        <Section style={caja}>
          <Text style={titulo}>
            {es ? 'Reservas' : 'Bookings'}: <b>{`{{recurrenceTotal}}`}</b>
          </Text>
          {/* Una línea por fecha, con su hora y su sala. El texto viene hecho
              desde la reserva: la plantilla no sabe recorrer listas. */}
          <Text style={lista}>{es ? `{{recurrenceFechas}}` : `{{recurrenceFechasEn}}`}</Text>
          <Text style={pie}>
            {es ? 'A nombre de' : 'Booked by'}: <b>{`{{namesAndSurnames}}`}</b> ·{' '}
            <b>{`{{numberPeople}}`}</b> {es ? 'personas' : 'people'}
          </Text>
        </Section>

        <Footer {...footer1} />
        <Footer {...footer2} />
      </Section>
    </Container>
  );
};

type FooterProps = {
  value?: string;
  url?: string;
  urlTitle?: string;
};

const Footer = ({ value, url, urlTitle }: FooterProps) => {
  return (
    <Text style={text}>
      {value}
      {url && (
        <Link target='_blank' href={url}>
          {' ' + urlTitle}
        </Link>
      )}
    </Text>
  );
};

export default TemplateRecurringReservationEmail;

const container = {
  backgroundColor: '#ffffff',
  border: '1px solid #f0f0f0',
  padding: '30px',
  margin: '0 auto',
  width: '100%',
};

const text = {
  fontSize: '14px',
  fontWeight: '300',
  color: '#404040',
  padding: '0px 16px',
};

const caja = {
  backgroundColor: '#f6f9fc',
  borderRadius: '6px',
  margin: '16px',
  padding: '12px 4px',
};

const titulo = {
  fontSize: '13px',
  fontWeight: '300',
  color: '#404040',
  margin: '0px',
  padding: '2px 16px',
};

/** Las fechas: algo más de aire entre líneas, que son varias seguidas. */
const lista = {
  fontSize: '13px',
  fontWeight: '300',
  color: '#404040',
  lineHeight: '22px',
  margin: '8px 0px 0px',
  padding: '0px 16px',
};

const pie = {
  fontSize: '12px',
  fontWeight: '300',
  color: '#707070',
  margin: '10px 0px 0px',
  padding: '0px 16px',
};
